module.exports = __webpack_public_path__ + "img/箱包2.af1ade5f.png";